import type { FC } from 'react'

export const Text: FC = () => null
